export default {
  phoneInput: {
    height: '56px',
    fontSize: '16px',
    fontWeight: 'normal',
    marginTop: '18px',
  },
};
